module.exports = "/packs/images/sprites/social~120aa5efaef57be9b404e59cd9da8aea.png";